import {StoreData} from "../../StoreDetail/StoreDetailServices";
import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import './sections.scss'
import {MenuList} from "./MenuList";
import {MenuRootList} from "./MenuRootList";

const MyRecentMerchant = ({item}) =>{

    const history = useHistory();

    const mapsSelector = () => {
        let coordinates = item.geometry? item.geometry.coordinates:null;
        if (coordinates) {
            if /* if we're on iOS, open in Apple Maps */
            ((navigator.platform.indexOf("iPhone") !== -1) ||
                (navigator.platform.indexOf("iPad") !== -1) ||
                (navigator.platform.indexOf("iPod") !== -1))
                window.open("maps://maps.google.com/maps?daddr=" + coordinates[0] + "," + coordinates[1] + "&amp;ll=");
            else /* else use Google */
                window.open("https://maps.google.com/maps?daddr=" + coordinates[0] + "," + coordinates[1] + "&amp;ll=");
        }
    }


    const getMerchant = async () =>{
        try {
            let response = await StoreData(item.items[0].link_to_uid);
            setLast(response.data)
        } catch (e) {
            // console.log(e)
        }
    }
    const [last,setLast] = useState()
    useEffect(()=>{
        getMerchant()
    },[])


    return(
        <div  style={{margin: "20px 16px 0 16px"}}>
            {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
            <div className="MyRecentMerchant-container">
                {last?
                    <div>
                        <div className="last-title">
                            <span className="last-title-hint">(آخرین مراجعه شما)</span>
                            <span className="last-title-name">{last.name}</span>
                        </div>
                        <div className="storeDetail-actions" style={{marginBottom:70}}>
                            <div className="storeDetail-actions-item" onClick={()=>{
                                if(last && last.phone){
                                    document.location.href="tel:"+last.phone;
                                }else {
                                    //document.location.href="tel:"+'';
                                }
                            }}>
                                <img src="/svg//phone.svg" alt=""/>
                                <span>تماس</span>
                            </div>
                            <div className="storeDetail-actions-item" onClick={()=>mapsSelector()}>
                                <img src="/svg//direction.svg" alt=""/>
                                <span>مسیر یابی</span>
                            </div>
                            <div className="storeDetail-actions-item" onClick={
                                ()=>{
                                    history.push(`/chat/${last.topic}`,{merchant:last})
                                }
                            }>
                                <img src="/svg//chat.png" alt=""/>
                                <span>چت</span>
                            </div>
                        </div>

                        <MenuList item={item}/>
                    </div>
                    :null}
            </div>
        </div>
    )
}

export {MyRecentMerchant}
